// removed by extract-text-webpack-plugin
module.exports = {"shareButtonCell":"_3thxOxCOjvkcPJFsV_Tz6V","shareButton":"_1RlVN5qqebkSCQ3hIPl89I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientProjectsListItem/RecipientProjectsListItem.scss
// module id = 1327
// module chunks = 1